import PropTypes from "prop-types";
import {
	StyledSelectableUpperUnit,
	StyledSelectableUpperUnitWrapper,
} from "../../../styles/StyledSelectableUpperUnits/StyledSelectableUpperUnit";

const SelectableRadioDecision = ({ data, value, selectedDecision }) => {
	const { name } = data;

	return (
		<StyledSelectableUpperUnit checked={selectedDecision === value}>
			<StyledSelectableUpperUnitWrapper>
				<p>{name}</p>
			</StyledSelectableUpperUnitWrapper>
			<input type="radio" name="decisionMember" value={value} defaultChecked={selectedDecision === value} />
			<span className="checkmark"></span>
		</StyledSelectableUpperUnit>
	);
};

export default SelectableRadioDecision;

SelectableRadioDecision.propTypes = {
	value: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
	selectedDecision: PropTypes.string,
	data: PropTypes.object,
};
